import $ from 'jquery';
import manager from 'app/module46/component-manager.js';

manager.register('accordion', (component) => {
	$(component).accordion();
});
